import { Navigate } from 'react-router-dom';

import Orders from "@/layouts/navigation/components/Orders";
import OrdersCompleted from "@/pages/orders/completed";
import OrdersConfirmed from "@/pages/orders/confirmed";
import OrderDetails from "@/pages/orders/order-details";
import OrdersSent from "@/pages/orders/sent";

const OrderRoutes = [
  {
    element: <Orders/>,
    children: [
      { path: "/orders/confirmed", element: <OrdersConfirmed/> },
      { path: "/orders/pending", element: <Navigate to="/orders/confirmed" replace /> },
      { path: "/orders/sent", element: <OrdersSent/> },
      { path: "/orders/completed", element: <OrdersCompleted/> },
    ]
  },

  { path: "/order/:orderNumber", element: <OrderDetails/> },
];

export default OrderRoutes;
